import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-loading-animation2',
  templateUrl: './loading-animation2.component.html',
  styleUrls: ['./loading-animation2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingAnimation2Component {}
